import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Countdown = ({ duration, onComplete, render, start }) => {
  const [countdown, setCountdown] = useState(duration);
  useEffect(() => {
    let interval = null;
    if (start) {
      interval = setInterval(() => {
        if (countdown > 0) return setCountdown(countdown - 1);

        clearInterval(interval);
        return onComplete();
      }, 1000);
    }

    if (!start) {
      // reset timer
      setCountdown(duration);
    }

    return function cleanup() {
      if (interval) clearInterval(interval);
    };
  }, [start, countdown]);

  return render(countdown);
};

Countdown.defaultProps = {
  start: true,
};
Countdown.propTypes = {
  duration: PropTypes.number.isRequired,
  onComplete: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  start: PropTypes.bool,
};
export default Countdown;
